import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISearchInput from 'UIComponents/input/UISearchInput';
import styled, { theme } from '../../../utils/Styling';
const SearchForm = styled(UIFormControl).withConfig({
  displayName: "CardSearchInput__SearchForm",
  componentId: "sc-11gdry0-0"
})(["width:100%;padding:10px;background-color:", ";"], theme.colors.GYPSUM);
const SearchFormInput = styled(UISearchInput).withConfig({
  displayName: "CardSearchInput__SearchFormInput",
  componentId: "sc-11gdry0-1"
})(["input:placeholder-shown{text-overflow:ellipsis;}"]);

const CardSearchInput = ({
  onSearchChange,
  placeholder
}) => {
  const handleOnChange = e => {
    const searchInput = e.target.value.trim().toLowerCase();
    onSearchChange(searchInput.length > 2 ? searchInput : '');
  };

  const searchPlaceholder = I18n.text(placeholder);
  return /*#__PURE__*/_jsx(SearchForm, {
    "aria-label": searchPlaceholder,
    children: /*#__PURE__*/_jsx(SearchFormInput, {
      onChange: handleOnChange,
      placeholder: searchPlaceholder,
      use: "on-dark"
    })
  });
};

export default CardSearchInput;